<template>
  <table
    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>Aspectos e Situação Familiar</b></h5>
        </th>
      </tr>

      <tr>
        <td colspan="4">
          <b>SITUAÇÃO FAMILIAR</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          POSSUI FAMÍLIA NATURAL, COM VINCULAÇÃO AFETIVA POSITIVA?
          <b>{{ usuario.vinculacao_afetiva_positiva ?? '-' }}</b>
        </td>

        <td colspan="2">
          DISPÕE DE DADOS SOBRE A FAMÍLIA NATURAL?
          <b>{{ usuario.dados_familia_natual ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          POSSUI FAMÍLIA NATURAL, MAS NÃO APRESENTA VINCULAÇÃO AFETIVA POSITIVA?
          <b>{{ usuario.familia_natural_sem_vinculacao_afetiva_positiva ?? '-' }}</b>
        </td>

        <td colspan="2">
          HÁ IMPEDIMENTO JUDICIAL PARA CONTATO COM A FAMÍLIA NATURAL?
          <b>{{ usuario.impedimento_judicial ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td>
          ESTÁ EM SITUAÇÃO DE ORFANDADE?
          <b>{{ usuario.situacao_orfandade ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          <b>Aspectos Sociofamiliares</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          AVALIAÇÃO SOBRE OS VÍNCULOS FAMILIARES?
          <b>{{ usuario.avaliacao_vinculo ?? '-' }}</b>
        </td>

        <td colspan="2">
          RESPEITA AS REGRAS ESTABELECIDAS PELOS GENITORES/RESPONSÁVEIS?
          <b>{{ usuario.respeita_regra_responsaveis ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          CHEGA TARDE DA NOITE EM CASA?
          <b>{{ usuario.chega_tarde_casa ?? '-' }}</b>
        </td>

        <td colspan="2">
          QUANTO TEMPO PASSA NA RUA?
          <b>{{ usuario.tempo_na_rua ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          NECESSIDADE DE TABELA DE HORÁRIOS?
          <b>{{ usuario.tabela_horario ?? '-' }}</b>
        </td>

        <td colspan="2">
          OBSERVAÇÃO SOBRE OUTROS VÍNCULOS AFETIVOS FORA DO GRUPO FAMILIAR E PARTICIPAÇÃO
          DE GRUPOS SOCIAIS
          <span v-html="usuario.observacoes"></span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["usuario"],
};
</script>